import styled from 'styled-components';
import GameHeader from './componant/GameHeaderback';
import Footer from '../components/footer/Footer';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import GameService from '../../service/game/GameService';
import { useModal } from '../../context/ModalContext';
import { isLogin } from '../../utils/auth';
import UserAlert from '../components/userAlert/UserAlert';

const OpenGraph = () => {
  const [matches, setMatches] = useState<any[]>([]);
  const [currentMatchIndex, setCurrentMatchIndex] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const [initialState] = useState(() => {
    if (location.state) {
      return location.state;
    } else {
      try {
        const saved = localStorage.getItem('ongoingGame');
        return saved ? JSON.parse(saved) : null;
      } catch {
        return null;
      }
    }
  });
  const { gameData, playId, playerId } = location.state || {};
  const [activeShareIndex, setActiveShareIndex] = useState<number | null>(null);
  const [activeStartIndex, setActiveStartIndex] = useState<number | null>(null);
  const [round, setRound] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const { modalDispatch } = useModal();

  useEffect(() => {
    if (!gameData || !playId || !playerId) {
      navigate('/', { replace: true });
    }
  }, [gameData, playId, playerId]);
  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const res = await GameService.getMatch(
          gameData.game_id,
          playId,
          round,
          playerId,
        );
        console.log('[매치 조회 응답]', res);
        setMatches(res.data || []);
        setCurrentMatchIndex(0); // 첫 매치부터 시작
      } catch (error) {
        console.error('[매치 조회 에러]', error);
      }
    };

    if (gameData && playId && playerId) {
      fetchMatches();
    }
  }, [gameData, playId, playerId, round]);

  const currentMatch = matches[currentMatchIndex];

  const handleSelect = async (winnerItemId: number) => {
    if (
      !currentMatch ||
      !gameData?.game_id ||
      !playerId ||
      playId === undefined
    ) {
      console.warn('[handleSelect] 필수 정보가 부족합니다.');
      return;
    }

    const matchId = currentMatch.match_id;
    const gameId = gameData.game_id;

    try {
      await GameService.selectWinner(
        gameId,
        playId,
        matchId,
        playerId,
        winnerItemId,
      );

      const selectedItem =
        winnerItemId === currentMatch.left_item_id
          ? currentMatch.left_item
          : currentMatch.right_item;

      setSelectedItems((prev) => [...prev, selectedItem]);

      if (currentMatchIndex < matches.length - 1) {
        setCurrentMatchIndex((prev) => prev + 1);
      } else {
        try {
          const nextRound = round + 1;
          await GameService.createMatch(gameId, playId, nextRound, playerId);
          setRound((prev) => prev + 1);
        } catch (err: any) {
          navigate(`/game/result/${gameId}/${playId}/${playerId}`);
        }
      }
    } catch (error) {
      console.error('❌ [승자 선택 에러]', error);
      alert('승자 선택 중 오류가 발생했습니다.');
    }
  };

  function formatKoreanWon(amount: number | string) {
    if (typeof amount === 'string') {
      amount = parseFloat(amount.replace(/,/g, ''));
    }
    if (typeof amount !== 'number' || isNaN(amount)) return '-';
    const isNegative = amount < 0;
    amount = Math.abs(amount);
    const units = [
      { value: 100000000, label: '억 ' },
      { value: 10000, label: '만' },
    ];
    let result = '';
    for (let unit of units) {
      if (amount >= unit.value) {
        const unitCount = Math.floor(amount / unit.value);
        amount %= unit.value;
        result += unitCount + unit.label;
      }
    }
    if (!result) {
      result = amount.toLocaleString() + '원';
    }
    return isNegative ? '-' + result : result;
  }
  const progress =
    matches.length > 0 ? ((currentMatchIndex + 1) / matches.length) * 100 : 0;
  const onSelect = (index: number, winnerItemId: number) => {
    setSelectedIndex(index);
    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      handleSelect(winnerItemId);
      setSelectedIndex(null);
    }, 1000);
  };

  const isLoggedIn = !!localStorage.getItem('accessToken');
  useEffect(() => {
    if (gameData && playId && playerId) {
      localStorage.setItem(
        'ongoingGame',
        JSON.stringify({
          gameData,
          playId,
          playerId,
          round,
          currentMatchIndex,
        }),
      );
    }
  }, [gameData, playId, playerId, round, currentMatchIndex]);
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const toggleExpand = (key: string) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };

  const renderTags = (tags: string[] = [], key: string, max: number) => {
    if (!tags.length) return null;

    const isExpanded = expandedRows.has(key);
    const visibleTags = isExpanded ? tags : tags.slice(0, max);
    const remainingCount = isExpanded ? 0 : Math.max(tags.length - max, 0);

    return (
      <>
        {visibleTags.map((tag, i) => {
          if (tag.startsWith('__STATUS__')) {
            return (
              <TagRed key={`${key}-${i}`}>
                {tag.replace('__STATUS__', '')}
              </TagRed>
            );
          }
          return tag.includes('대항력') ? (
            <TagBlue key={`${key}-${i}`}>{tag}</TagBlue>
          ) : (
            <TagGray key={`${key}-${i}`}>{tag}</TagGray>
          );
        })}

        {remainingCount > 0 && (
          <TagGray
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(key);
            }}
            style={{ cursor: 'pointer' }}
          >
            +{remainingCount}개
          </TagGray>
        )}
        {isExpanded && (
          <TagGray
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(key);
            }}
            style={{ cursor: 'pointer' }}
          >
            접기
          </TagGray>
        )}
      </>
    );
  };
  const [isButtonWrapVisible, setIsButtonWrapVisible] = useState(true);
  const buttonWrapRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsButtonWrapVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      },
    );

    const timer = setTimeout(() => {
      if (buttonWrapRef.current) {
        observer.observe(buttonWrapRef.current);
      }
    }, 0); // 0ms => 다음 tick

    return () => {
      clearTimeout(timer);
      if (buttonWrapRef.current) {
        observer.unobserve(buttonWrapRef.current);
      }
    };
  }, []);

  return (
    <Container>
      <GameHeader title={gameData?.title} />

      <Content>
        <Inner>
          <DetailsTop>
            <HighBarWrap>
              <HighBar>
                <HighBarGraph style={{ width: `${progress}%` }}>
                  <HighBarDetail></HighBarDetail>
                </HighBarGraph>
              </HighBar>
              <HighBarText>
                <HighText>
                  {matches.length * 2}강 ({currentMatchIndex + 1}/
                  {matches.length})
                </HighText>
                <HighText>총 {matches.length} 라운드</HighText>
              </HighBarText>
              <HighBarTitle>
                두 물건 중 더 투자하고 싶은 물건을 선택하세요!
              </HighBarTitle>
            </HighBarWrap>
          </DetailsTop>
          <CardList>
            {currentMatch && (
              <div key={currentMatch.match_id}>
                <BottomListWrap>
                  <BottomList className={selectedIndex === 1 ? 'lose' : ''}>
                    {/* 왼쪽 아이템 */}
                    <BottomBox>
                      <BottomImg
                        className={`left ${
                          selectedIndex === null
                            ? ''
                            : selectedIndex === 0
                              ? 'left-win'
                              : 'lose'
                        }`}
                      >
                        <img
                          src={
                            currentMatch.left_item?.thumb ||
                            '/assets/images/game/default.png'
                          }
                          alt="썸네일"
                        />
                        {selectedIndex !== null && (
                          <ResultText
                            className={selectedIndex === 0 ? 'win' : 'lose'}
                          >
                            {selectedIndex === 0 ? '승' : '패'}
                          </ResultText>
                        )}
                      </BottomImg>
                      {selectedIndex === null && (
                        <BottomInfo className="left">
                          <ShareBtn
                            className={activeShareIndex === 0 ? 'active' : ''}
                            onClick={() => {
                              const iidx = currentMatch.left_item?.iidx;
                              localStorage.setItem(
                                'redirectAfterLogin',
                                '/game/detail',
                              );
                              if (!isLogin()) {
                                modalDispatch({
                                  type: 'USER_ALERT',
                                  payload: 'guest',
                                });
                                return;
                              }
                              if (iidx) {
                                window.open(
                                  `/auction/detail/${iidx}`,
                                  '_blank',
                                );
                              }
                            }}
                          >
                            자세히 보기
                            <img src="/assets/images/game/game_move_icon.svg" />
                          </ShareBtn>
                          <BottomInfoList>
                            <BottomInfoTitle>
                              <span>{currentMatch.left_item?.category}</span>{' '}
                              <TextBox>
                                {currentMatch.left_item?.buildingName ||
                                  currentMatch.left_item?.address}
                              </TextBox>
                            </BottomInfoTitle>
                            <BottomInfoText>
                              {currentMatch.left_item?.address}・{' '}
                              {currentMatch.right_item?.buildingArea}
                              ㎡(
                              {currentMatch.left_item?.landArea}평)
                            </BottomInfoText>
                            <TagWrap>
                              {renderTags(
                                [
                                  ...(currentMatch.left_item?.status
                                    ? [
                                        `__STATUS__${currentMatch.left_item.status}`,
                                      ]
                                    : []),
                                  ...(currentMatch.left_item?.tag ?? []),
                                ],
                                `${currentMatch.match_no}-L`,
                                3,
                              )}
                            </TagWrap>
                          </BottomInfoList>
                          <Description>
                            <DescriptionInfo>
                              <span>최저 입찰가</span>
                              <span>
                                {formatKoreanWon(
                                  currentMatch.left_item?.minPrice,
                                )}
                              </span>
                            </DescriptionInfo>
                            <DescriptionInfo>
                              <span>직전 실거래 매매가</span>
                              <span>
                                {isLogin() ? (
                                  formatKoreanWon(
                                    currentMatch.left_item?.dealPrice,
                                  )
                                ) : (
                                  <LoginBtn
                                    onClick={() =>
                                      modalDispatch({
                                        type: 'USER_ALERT',
                                        payload: 'guest',
                                      })
                                    }
                                  >
                                    로그인 후 확인
                                  </LoginBtn>
                                )}
                              </span>
                            </DescriptionInfo>
                            <DescriptionInfo>
                              <span>AI 추정가</span>
                              <span>
                                {isLogin() ? (
                                  formatKoreanWon(
                                    currentMatch.left_item?.aiPrice,
                                  )
                                ) : (
                                  <LoginBtn
                                    onClick={() =>
                                      modalDispatch({
                                        type: 'USER_ALERT',
                                        payload: 'guest',
                                      })
                                    }
                                  >
                                    로그인 후 확인
                                  </LoginBtn>
                                )}
                              </span>
                            </DescriptionInfo>
                          </Description>
                          <ButtonWrap>
                            <StartBtn
                              className={activeStartIndex === 0 ? 'active' : ''}
                              onClick={() => {
                                setActiveStartIndex(0);

                                setTimeout(() => {
                                  setActiveStartIndex(null);
                                }, 500);

                                onSelect(0, currentMatch.left_item_id);
                              }}
                            >
                              <div>A 선택하기</div>
                            </StartBtn>
                          </ButtonWrap>
                        </BottomInfo>
                      )}
                    </BottomBox>
                  </BottomList>

                  <BottomList className={selectedIndex === 0 ? 'lose' : ''}>
                    {/* 오른쪽 아이템 */}

                    <BottomBox>
                      <BottomImg
                        className={`right ${
                          selectedIndex === null
                            ? ''
                            : selectedIndex === 1
                              ? 'right-win'
                              : 'lose'
                        }`}
                      >
                        <img
                          src={
                            currentMatch.right_item?.thumb ||
                            '/assets/images/game/default.png'
                          }
                          alt="썸네일"
                        />
                        {selectedIndex !== null && (
                          <ResultText
                            className={selectedIndex === 1 ? 'win' : 'lose'}
                          >
                            {selectedIndex === 1 ? '승' : '패'}
                          </ResultText>
                        )}
                      </BottomImg>
                      {selectedIndex === null && (
                        <BottomInfo className="right">
                          <ShareBtn
                            className={activeShareIndex === 0 ? 'active' : ''}
                            onClick={() => {
                              const iidx = currentMatch.right_item?.iidx;
                              localStorage.setItem(
                                'redirectAfterLogin',
                                '/game/detail',
                              );
                              if (!isLogin()) {
                                modalDispatch({
                                  type: 'USER_ALERT',
                                  payload: 'guest',
                                });
                                return;
                              }
                              if (iidx) {
                                window.open(
                                  `/auction/detail/${iidx}`,
                                  '_blank',
                                );
                              }
                            }}
                          >
                            자세히 보기
                            <img src="/assets/images/game/game_move_icon.svg" />
                          </ShareBtn>
                          <BottomInfoList>
                            <BottomInfoTitle>
                              <span>{currentMatch.right_item?.category}</span>{' '}
                              <TextBox>
                                {currentMatch.right_item?.buildingName ||
                                  currentMatch.right_item?.address}
                              </TextBox>
                            </BottomInfoTitle>
                            <BottomInfoText>
                              {currentMatch.right_item?.address} ・{' '}
                              {currentMatch.right_item?.buildingArea}
                              ㎡(
                              {currentMatch.right_item?.landArea}평)
                            </BottomInfoText>
                            <TagWrap>
                              {renderTags(
                                [
                                  ...(currentMatch.right_item?.status
                                    ? [
                                        `__STATUS__${currentMatch.right_item.status}`,
                                      ]
                                    : []),
                                  ...(currentMatch.right_item?.tag ?? []),
                                ],
                                `${currentMatch.match_no}-R`,
                                3,
                              )}
                            </TagWrap>
                          </BottomInfoList>
                          <Description>
                            <DescriptionInfo>
                              <span>최저 입찰가</span>
                              <span className={!isLoggedIn ? 'blur' : ''}>
                                {formatKoreanWon(
                                  currentMatch.right_item?.minPrice,
                                )}
                              </span>
                            </DescriptionInfo>
                            <DescriptionInfo>
                              <span>직전 실거래 매매가</span>
                              <span>
                                {isLogin() ? (
                                  formatKoreanWon(
                                    currentMatch.right_item?.dealPrice,
                                  )
                                ) : (
                                  <LoginBtn
                                    onClick={() =>
                                      modalDispatch({
                                        type: 'USER_ALERT',
                                        payload: 'guest',
                                      })
                                    }
                                  >
                                    로그인 후 확인
                                  </LoginBtn>
                                )}
                              </span>
                            </DescriptionInfo>
                            <DescriptionInfo>
                              <span>AI 추정가</span>
                              <span>
                                {isLogin() ? (
                                  formatKoreanWon(
                                    currentMatch.right_item?.aiPrice,
                                  )
                                ) : (
                                  <LoginBtn
                                    onClick={() =>
                                      modalDispatch({
                                        type: 'USER_ALERT',
                                        payload: 'guest',
                                      })
                                    }
                                  >
                                    로그인 후 확인
                                  </LoginBtn>
                                )}
                              </span>
                            </DescriptionInfo>
                          </Description>
                          <ButtonWrap>
                            <StartBtn02
                              className={activeStartIndex === 1 ? 'active' : ''}
                              onClick={() => {
                                setActiveStartIndex(1);

                                setTimeout(() => {
                                  setActiveStartIndex(null);
                                }, 500);

                                onSelect(1, currentMatch.right_item_id);
                              }}
                            >
                              <div>B 선택하기</div>
                            </StartBtn02>
                          </ButtonWrap>
                        </BottomInfo>
                      )}
                    </BottomBox>
                  </BottomList>
                </BottomListWrap>
                <GameVsBox
                  className={
                    selectedIndex === null
                      ? 'center'
                      : selectedIndex === 0
                        ? 'left-lose'
                        : 'right-lose'
                  }
                >
                  <img src="/assets/images/game/game_vs.svg" />
                </GameVsBox>
              </div>
            )}
          </CardList>
          <div ref={buttonWrapRef} style={{ height: 1 }} />
          {!isButtonWrapVisible && selectedIndex === null && (
            <FloatingButtonWrap>
              <FloatStartBtn
                className={activeStartIndex === 0 ? 'active' : ''}
                onClick={() => {
                  setActiveStartIndex(0);

                  setTimeout(() => {
                    setActiveStartIndex(null);
                  }, 500);

                  onSelect(0, currentMatch.left_item_id);
                }}
              >
                A 선택하기
              </FloatStartBtn>
              <FloatStartBtn02
                className={activeStartIndex === 1 ? 'active' : ''}
                onClick={() => {
                  setActiveStartIndex(1);

                  setTimeout(() => {
                    setActiveStartIndex(null);
                  }, 500);

                  onSelect(1, currentMatch.right_item_id);
                }}
              >
                B 선택하기
              </FloatStartBtn02>
            </FloatingButtonWrap>
          )}

          <BottomText>
            <BottomTextBox>
              <img src="/assets/images/icon/icon_light.svg" />
              투자 기준을 생각하며 선택해보세요 <br /> 수익성, 안정성, 성장성,
              유동성
            </BottomTextBox>
          </BottomText>
        </Inner>
      </Content>
      <Footer />
      <UserAlert />
    </Container>
  );
};

export default OpenGraph;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 100%;
`;
const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;

const HighBarWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 12px;
`;

const HighBar = styled.div`
  width: 100%;
  height: 16px;
  border-radius: 999px;
  background: #e5e5e5;
  position: relative;
`;

const DetailsTop = styled.div`
  margin-top: 24px;
`;

const HighBarText = styled.div`
  display: flex;
  flex-direction: row;
  height: 26px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  position: relative;
`;

const HighText = styled.div`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  color: rgba(0, 12, 30, 0.8);
`;

const HighBarTitle = styled.div`
  display: flex;
  padding: 7px 0;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  border-radius: 7px;
  background: #f3f4f6;
  color: #333d48;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const CardList = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  position: relative;
  padding: 0 12px;
  width: 100%;
  > div {
    width: 100%;
    position: relative;
  }
`;

const BottomListWrap = styled.div`
  display: flex;
  align-self: stretch;
  margin-bottom: 40px;
  width: 100%;
`;
const BottomList = styled.div`
  width: 100%;
  min-height: 495px;
  transition: 0.3s;
  &.lose {
    width: 50%;
  }
`;

const BottomBox = styled.div`
  border-radius: 20px;
  background: #fff;
  height: 100%;
  width: 100%;
`;

const BottomImg = styled.div`
  height: 150px;
  width: calc(100% - 4px);
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  &.left {
    margin: 16px 4px 12px 0px;
  }
  &.right {
    margin: 16px 0px 12px 4px;
  }
  &.left-win {
    border: 4px solid #1f7aff;
  }
  &.right-win {
    border: 4px solid #fe7122;
  }
  &.lose {
    &:after {
      display: block;
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      z-index: 1;
    }
  }
  > img {
    position: absolute;
    width: 100%;
    height: 110%;
    left: 50%;
    transform: translate(-50%);
    object-fit: cover;
  }
`;
const BottomInfo = styled.div`
  display: flex;
  width: 100%;
  &.left {
    padding-right: 12px;
  }
  &.right {
    padding-left: 12px;
  }
  flex-direction: column;
  gap: 12px;
`;

const BottomInfoTitle = styled.div`
  color: rgba(0, 12, 30, 0.8);

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  gap: 2px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 40px;
  span {
    color: #008aff;
    font-size: 12px;
    font-weight: 700;
  }
`;
const TextBox = styled.div`
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  top: 20px;
`;
const BottomInfoText = styled.div`
  color: #6b7684;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  flex-direction: column;
`;

const DescriptionInfo = styled.div`
  border-radius: 8px;
  background: #f7f8fc;
  display: flex;
  width: 100%;
  padding: 8px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  span {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;
    align-self: stretch;
  }
  span:first-child {
    color: #6b7684;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 150%; /* 21px */
    letter-spacing: -0.28px;
  }
  span:last-child {
    color: #222;
    text-align: center;
    font-family: 'Spoqa Han Sans Neo';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 145%; /* 26.1px */
    letter-spacing: -0.36px;
    display: flex;
    justify-content: space-between;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  align-self: stretch;
  flex-direction: column;
`;

const ShareBtn = styled.div`
  display: flex;
  padding: 7px 8px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  border-radius: 7px;
  background: #e7f0fe;
  color: #008aff;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;
const StartBtn = styled.div`
  width: 100%;
  height: 46px;
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #fff;
    font-family: NanumSquareRoundOTF;
    font-size: 15px;
    font-style: normal;
    font-weight: 800;
    line-height: 145%; /* 26.1px */
    letter-spacing: -0.36px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #1f7aff;
    transition: 0.1s;
    bottom: 0px;
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #0d538f;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;
const StartBtn02 = styled.div`
  width: 100%;
  height: 46px;
  position: relative;
  cursor: pointer;
  > div {
    border-radius: 12px;
    width: 100%;
    height: 100%;
    flex-direction: row;
    gap: 8px;
    display: inline-flex;
    padding: 16px 20px;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #fff;
    font-family: NanumSquareRoundOTF;
    font-size: 15px;
    font-style: normal;
    font-weight: 800;
    line-height: 145%; /* 26.1px */
    letter-spacing: -0.36px;
    white-space: nowrap;
    position: absolute;
    z-index: 1;
    background: #fe7122;
    transition: 0.1s;
    bottom: 0px;
  }
  &:after {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background: #cc5a1a;
    display: block;
    content: '';
    position: absolute;
    z-index: 0;
    bottom: -3px;
  }
  &.active {
    > div {
      bottom: -3px;
    }
  }
`;

const BottomInfoList = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

const TagWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-direction: row;
  align-self: stretch;
  height: auto;
  flex-wrap: wrap;
  min-height: 55px;
`;

const TagRed = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fff0f0;
  color: #f04452;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const TagBlue = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #e7f0fe;
  color: #008aff;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const TagGray = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border-radius: 4px;
  background: #f4f5f9;
  color: #4e5968;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;

const BottomText = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding: 0 12px 120px;
`;

const BottomTextBox = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 24px;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: #e9f5ff;
  flex-direction: row;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
  color: rgba(0, 12, 30, 0.8);
`;

const GameVsBox = styled.div`
  display: flex;
  height: 32px;
  padding: 6px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(28, 28, 28, 0.2);
  position: absolute;
  top: 70px;
  transform: translateX(-50%);
  z-index: 100;
  transition: 0.3s;
  &.center {
    left: 50%;
  }
  &.left-lose {
    left: 66%;
  }
  &.right-lose {
    left: 33%;
  }
`;

const HighBarGraph = styled.div`
  height: 100%;
  position: absolute;
  background: #008aff;
  border-radius: 999px;
`;

const HighBarDetail = styled.div`
  width: calc(100% - 10px);
  height: 4px;
  border-radius: 999px;
  background: #36a3ff;
  margin: 3px 5px 9px;
`;
const NextBox = styled.div`
  margin-top: 40px;
  padding: 0 16px 24px 16px;
`;
const ResultText = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  line-height: 25.5px;
  z-index: 2;
  font-weight: 700;
  &.win {
    font-size: 24px;
    font-style: normal;
  }
  &.lose {
    font-size: 16px;
    font-style: normal;
  }
`;

const RetryBtn = styled.div`
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #e5e8eb;
  color: rgba(0, 12, 30, 0.8);

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 185px;
`;

const LoginBtn = styled.div`
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #e7f0fe;
  color: #008aff;
  text-align: center;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  cursor: pointer;
`;

const FloatingButtonWrap = styled.div`
  display: flex;
  gap: 24px;
  padding: 19px 12px 24px;
  position: fixed;
  bottom: 0px;
  width: 100%;
  background: #fff;
  z-index: 10;
`;
const FloatStartBtn = styled.div`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #1f7aff;
  color: #fff;
  text-align: center;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;
const FloatStartBtn02 = styled.div`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #fe7122;
  color: #fff;
  text-align: center;

  /* Re_SPOQA/body/bold_16 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;
